<template>
    <TopNav></TopNav>
		<h1>Currency Converter</h1>
		<fieldset>
      <legend>Currency Converter</legend>
      <label for="us">USD:</label> <input type="number" v-model.number="usd" step="any" @input="onUSDChange" autofocus id="us"> <label for="us">$</label>
			<br>
      <label for="eu">EUR:</label> <input type="number" v-model.number="eur" step="any" @input="onEURChange" id="eu"> <label for="eu">€</label>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Currency",
  data() {
    return {
      usd: 0,
      eur: 0
    }
  },
  components: {
    TopNav
  },
  methods: {
    onUSDChange(e) {
      const dollar = e.currentTarget.value;
      this.eur = dollar * 0.84742;
    },
    onEURChange(e) {
      const euro = e.currentTarget.value;
      this.usd = euro * 1.18006;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 50px;
}

footer section a {
  margin: 20px;
}
</style>
